import { EditorDefaultSidePanelType, setActiveSidePanel } from 'components/editor/grid/reduxStore/blockStyleSettingsSlice';
import { SelectionContext } from 'components/editor/GridDndEditor/SelectedBlockInfoProvider';
import { useActiveEditor } from 'components/editor/GridDndEditor/TiptapEditor/ActiveEditorContext';
import { useMultiEditor } from 'components/editor/GridDndEditor/TiptapEditor/MultiEditorContext';
import { SecondaryMenu } from 'components/editor/SidePanel/component';
import { openNotification } from 'components/notification';
import { useContext, useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { trackError } from '@proposify/frontend-observability';
import { Snippets } from 'components/library/snippets/Snippets';
import type { JSONContent } from '@tiptap/core';

export const TextSnippetsPanel = () => {
  const dispatch = useDispatch();
  const { setActiveEditor, setIsEditMode } = useActiveEditor();
  const [textInsertionPositions, setTextInsertionPositions] = useState<{ from: number; to: number } | null>(null);

  const { selectedBlockIdByWrapper: blockId } = useContext(SelectionContext) as { selectedBlockIdByWrapper: string };

  const { getEditor } = useMultiEditor();
  const blockEditor = useMemo(() => getEditor(`tiptap_editor_${blockId}`), [blockId, getEditor]);

  useEffect(() => {
    if (!blockEditor) return;
    const { from, to } = blockEditor.state.selection;
    setTextInsertionPositions({ from, to });
  }, []);

  const handleBackButtonClick = () => {
    dispatch(setActiveSidePanel({ type: EditorDefaultSidePanelType.EDITOR_DEFAULT_SIDE_PANEL }));
  };

  const handleInsertSnippet = async (newContent: JSONContent) => {
    try {
      if (!blockEditor) throw new Error('Unexpected error: Block editor not found');
      setIsEditMode(true);
      setActiveEditor(blockEditor);

      if (textInsertionPositions) {
        const { from, to } = textInsertionPositions;
        blockEditor.chain().focus().insertContentAt({ from, to }, newContent).run();
      } else {
        blockEditor.chain().focus().selectTextblockEnd().insertContent(newContent).run();
      }

      blockEditor.chain().focus().selectTextblockEnd().run();
      setTextInsertionPositions(null);
    } catch (error) {
      trackError(error as Error);
      openNotification({
        type: 'error',
        title: "Sorry, we couldn't insert the text snippet",
      });
    }
  };

  return (
    <SecondaryMenu menuTitle="Snippets" backButtonOnClick={handleBackButtonClick}>
      <Snippets onInsertSnippet={handleInsertSnippet} />
    </SecondaryMenu>
  );
};
